import React from 'react'
import { Button as ShadCNButton, ButtonProps as ShadCNButtonProps } from '@/components/ui/button'
import clsx from 'clsx'

interface CustomButtonProps extends ShadCNButtonProps {
  children: React.ReactNode
  className?: string
}

export function Button ({ children, className, ...props }: CustomButtonProps): JSX.Element {
  return (
    <ShadCNButton className={clsx('flex gap-1 items-center text-white hover:bg-primary-950 rounded-[6px] text-[14px] pr-5 pl-5', className)} {...props}>
      {children}
    </ShadCNButton>
  )
}
